import { Component, useContext } from 'react';
import { DateFilterWidget, getFromDateFromFilter, getToDateFromFilter } from './dateFilter';
import { AppContext } from '@context/app-context';
import { Box, Card, CircularProgress, Stack, } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { getSalesRecon } from '@src/api/reportHandlers';
import EnhancedTable from '@components/enhancedDataGrid';
import dayjs from 'dayjs';

export default function SalesReconReport() {
  const { storeId, allStoresDetails } = useContext(AppContext);
  const storeDetails = allStoresDetails.find(x => x.storeId === storeId) ?? {
    storeId,
    storeName: storeId,
    locale: 'en_US',
    timeZone: 'Asia/Muscat'
  }
  const [searchParams] = useSearchParams();
  const filterParams = Object.fromEntries([...searchParams]);
  return (
    <SalesReconReportView
      storeId={storeId}
      storeDetails={storeDetails}
      currentFromDate={filterParams.currentFromDate}
      currentToDate={filterParams.currentToDate}
    />
  );
}
class SalesReconReportView extends Component {
  constructor(props) {
    super(props);
    const { storeId, storeDetails } = this.props;
    this.loadReports = this.loadReports.bind(this);
    this.state = {
      storeId,
      reportData: {},
      status: 'LOADING',
      storeDetails
    };
  }

  componentDidMount() {
    const { currentFromDate, currentToDate } = this.props;
    if (currentFromDate == null || currentToDate == null) {
      this.loadReports(getFromDateFromFilter('TODAY'), getToDateFromFilter('TODAY'));
    } else {
      this.loadReports(currentFromDate, currentToDate,
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.storeId !== prevProps.storeId) {
      this.componentDidMount();
    }
  }

  loadReports(fromDate, toDate) {
    const { storeId } = this.props;
    console.log('Loading reports');
    this.setState({
      reportData: null,
      status: 'LOADING',
    });
    getSalesRecon(fromDate, toDate, storeId).then((data) => {
      this.setState({
        reportData: data,
        storeId,
        status: 'LOADED',
      });
    }).catch((err) => {
      console.log('Error while fetching SalesRecon', err.message);
      this.setState({
        reportData: null,
        storeId,
        status: 'ERROR',
      });
    });
  }


  render() {
    const { reportData, status } = this.state;
    const { storeId, storeDetails } = this.props;
    const { currentFromDate, currentToDate } = this.props;
    let dataTemp = reportData?.items ?? [];
    let data = [];

    let i = 0;
    dataTemp.forEach(datapoint => {
      data.push({ ...datapoint, id: i, name: datapoint.method, date: dayjs(datapoint.date).tz(storeDetails.timeZone).format('DD-MMM-YYYY') });
      i++;
    });

    const headCells = [
      { id: 'reference', numeric: false, disablePadding: true, label: 'Order No', },
      { id: 'account', numeric: false, disablePadding: false, label: 'Transaction No', },
      { id: 'note', numeric: false, disablePadding: false, label: 'Note', },
      { id: 'mode', numeric: false, disablePadding: false, label: 'Mode', },
      { id: 'type', numeric: false, disablePadding: false, label: 'Type', },
      { id: 'date', numeric: false, disablePadding: false, label: `Order Date`, },
      { id: 'staff', numeric: false, disablePadding: false, label: 'Staff', },
      { id: 'method', numeric: false, disablePadding: false, label: 'Method', },
      { id: 'amount', numeric: true, disablePadding: false, label: 'Amount', },
      { id: 'tip', numeric: true, disablePadding: false, label: 'Tip', },
      { id: 'paid', numeric: true, disablePadding: false, label: 'Paid', },
      { id: 'legal_entity', numeric: false, disablePadding: false, label: 'Legal Entity', },
      { id: 'user_type', numeric: false, disablePadding: false, label: 'User Type', },
      { id: 'bu', numeric: false, disablePadding: false, label: 'BU', },
    ];


    return (
      <Box
        sx={{
          backgroundColor: '#e2e2e2',
          width: '100%',
          height: '100%',
          overflow: 'auto',
        }}
      >
        <Stack direction="column" sx={{ height: '100%', paddingX: 1, paddingY: 0 }} spacing={1}>
          <Box>
            <Card>
              <DateFilterWidget
                fetchReports={this.loadReports}
                fromDate={currentFromDate}
                toDate={currentToDate}
                storeDetails={storeDetails}
              />
            </Card>
          </Box>
          {status === 'LOADING' ?
            (<Stack direction="row" sx={{ height: '100%', width: '100%', paddingX: 2, paddingY: 1 }} spacing={2} justifyContent="center">
              <CircularProgress />
            </Stack>)
            : status === 'ERROR' ?
              (<Stack direction="row" justifyContent="center">Opps! We encountered an issue while fetching the report data!!</Stack >)
              : data ?
                <Box style={{
                  boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
                  borderRadius: '4px',
                  backgroundColor: 'white'
                }}>
                  <EnhancedTable
                    headCells={headCells}
                    rows={data}
                    title={'Accounting Groups'}
                    downloadFileName={`${storeDetails.storeName}_${storeId}_SALES_RECON.csv`} />
                </Box>
                :
                <>No Data</>}
        </Stack>
      </Box>
    )
  }
}
